import { VxeCheckbox } from 'vxe-pc-ui';
import defPropMixin from './defPropMixin';
export default {
  name: 'XCheckbox',
  components: {
    VxeCheckbox
  },
  mixins: [defPropMixin],
  props: {
    value: {
      type: [Number, String, Boolean],
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    // 是否不确定状态
    checkedValue: {
      type: [String, Number, Boolean],
      default: true
    },
    uncheckedValue: {
      type: [String, Number, Boolean],
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  emits: ['update:value', 'change'],
  setup(props, context) {
    const handleChanged = ({
      checked,
      value,
      $event
    }) => {
      context.emit('change', {
        checked,
        value,
        $event
      });
      context.emit('update:value', checked, $event);
    };
    return {
      handleChanged
    };
  }
};